import ReactMarkdown, { type Components } from 'react-markdown';
import { Link } from 'react-router';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

// Raw HTML in markdown is not rendered (react-markdown escapes it) and unsafe URL schemes are stripped.
const components: Components = {
  a: ({ href, children }) =>
    href?.startsWith('/') ? (
      <Link to={href}>{children}</Link>
    ) : (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  table: ({ children }) => (
    <div className="table-wrap">
      <table>{children}</table>
    </div>
  ),
};

export function Markdown({ children, className, fontScale }: { children: string; className?: string; fontScale?: number }) {
  return (
    <div className={cn('prose-clinical', className)} style={fontScale ? ({ '--font-scale': fontScale } as React.CSSProperties) : undefined}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
